

class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends HTMLElement {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this.mainDetailsToggle = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.content = this.summary.nextElementSibling;
    this.closeTimeout = null;
    
    // Add event listeners for hover
    this.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
    this.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
    
    // Add event listeners for the content area as well
    this.content.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
    this.content.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
    
    // Keep original event listeners for accessibility
    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
    
    // For touch devices
    this.summary.addEventListener('click', (event) => {
      // Prevent the default toggle behavior on touch devices
      if (window.matchMedia('(hover: none)').matches) {
        event.preventDefault();
        if (this.mainDetailsToggle.hasAttribute('open')) {
          this.closeMenu();
        } else {
          this.openMenu();
        }
      }
    });
  }
  
  handleMouseEnter() {
    // Clear any pending close timeout
    if (this.closeTimeout) {
      clearTimeout(this.closeTimeout);
      this.closeTimeout = null;
    }
    this.openMenu();
  }
  
  handleMouseLeave() {
    // Set a timeout to close the menu, allowing time to move to submenu
    this.closeTimeout = setTimeout(() => {
      this.closeMenu();
    },5);
  }
  
  openMenu() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', true);
    if (this.animations) {
      this.animations.forEach(animation => animation.play());
    }
    
    if (this.header) {
      this.header.preventHide = true;
    }
  }
  
  closeMenu() {
    // Don't close if a child element has focus
    if (this.contains(document.activeElement)) return;
    
    this.mainDetailsToggle.removeAttribute('open');
    this.summary.setAttribute('aria-expanded', false);
    if (this.animations) {
      this.animations.forEach(animation => animation.cancel());
    }
    
    if (this.header) {
      this.header.preventHide = false;
    }
  }
  
  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.closeMenu();
    });
  }
  
  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();
    
    if (this.header) {
      this.header.preventHide = this.mainDetailsToggle.open;
      if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
      document.documentElement.style.setProperty(
        '--header-bottom-position-desktop',
        `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
      );
    }
  }
}

customElements.define('header-menu', HeaderMenu);
